/* eslint-disable import-x/no-default-export */
import Chance from 'chance';
const chance = new Chance();

export default (location: string, ...args: any) => {
  const [suggestion] = args as [{ text: string; id: string }];
  const { text, id }: { text: string; id: string } = suggestion || {
    text: chance.word(),
    id: chance.guid(),
  };

  return {
    id,
    text,
    highlights: [
      {
        start:
          text.toLowerCase().indexOf(location.toLowerCase()) + location.length,
        end: text.length,
      },
    ],
    __typename: 'LocationSuggestion',
  };
};
